import { render, staticRenderFns } from "./NotificationSectionWrapper.vue?vue&type=template&id=641a1fd9&scoped=true&"
import script from "./NotificationSectionWrapper.vue?vue&type=script&lang=ts&"
export * from "./NotificationSectionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSectionWrapper.vue?vue&type=style&index=0&id=641a1fd9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a1fd9",
  null
  
)

export default component.exports